<!--
  EntityInputSelect.vue — the `entity-input-select` widget (also serves the
  `employee` picker and any select-backed field). Options come from
  field.params.items (item-value/item-text configurable per descriptor).

  Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
  (props value/field/rules/disabled/label; emits `input`; items sourced from
  field.params.items with params.itemValue/itemText keys), internal impl
  re-authored on the Vuetify 1.5 v-select.
-->
<template>
  <v-select
    :value="value"
    :items="items"
    :item-value="itemValue"
    :item-text="itemText"
    :label="resolvedLabel"
    :rules="rules"
    :disabled="disabled"
    :required="required"
    :clearable="!required"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'entity-input-select',
  props: {
    value: { default: null },
    field: { type: Object, default: () => ({}) },
    rules: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
  },
  computed: {
    params() { return (this.field && this.field.params) || {}; },
    items() { return this.params.items || this.params.options || []; },
    itemValue() { return this.params.itemValue || 'id'; },
    itemText() { return this.params.itemText || 'label'; },
    required() { return !!(this.field && this.field.required); },
    resolvedLabel() { return this.label || (this.field && this.field.label) || ''; },
  },
};
</script>
